import React, { useState } from 'react';
import { Card, Table, Tag, Badge } from 'antd';
import { WarningOutlined, DownOutlined, RightOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const columns = [
  {
    title: 'Tarih',
    dataIndex: 'date',
    key: 'date',
    width: 120,
    render: (v) => dayjs(v).format('DD.MM.YYYY ddd'),
  },
  {
    title: 'Saat',
    dataIndex: 'start_time',
    key: 'time',
    width: 70,
  },
  {
    title: 'Derslik',
    dataIndex: 'classroom',
    key: 'classroom',
  },
  {
    title: 'Proje Girilmemiş Öğrenciler',
    dataIndex: 'students',
    key: 'students',
    render: (students) => (
      <div className="flex flex-wrap gap-1">
        {(students || []).map((s, i) => (
          <Tag key={i} color="orange" style={{ margin: 0 }}>{s}</Tag>
        ))}
      </div>
    ),
  },
];

// Gecmise donuk kayitlar artik sadece Raporlar > Projesi Girilmemis Dersler
// sekmesinde - dashboard'da her personel icin sadece bugun gorunuyor.
const MissingProjectsPanel = ({ todaySessions = [], loading = false }) => {
  const [collapsed, setCollapsed] = useState(true);

  if (!loading && todaySessions.length === 0) return null;

  return (
    <Card
      size="small"
      title={
        <span
          className="cursor-pointer select-none flex items-center gap-2"
          onClick={() => setCollapsed(c => !c)}
        >
          {collapsed ? <RightOutlined style={{ fontSize: 11, color: '#9ca3af' }} /> : <DownOutlined style={{ fontSize: 11, color: '#9ca3af' }} />}
          <WarningOutlined style={{ color: '#faad14' }} />
          Projesi Girilmemiş Dersler — Bugün
          <Badge count={todaySessions.length} style={{ backgroundColor: '#faad14' }} />
        </span>
      }
      style={{ marginBottom: 16 }}
    >
      {!collapsed && (
        <Table
          dataSource={todaySessions}
          columns={columns}
          rowKey={(r) => r.date + r.classroom + r.start_time}
          size="small"
          loading={loading}
          pagination={{
            // Aynı tuzak (bkz. MissingProjectsReportTab): `pageSize` alanı
            // kontrollü yapıyor. Seçici de kapalıydı, yani 10'a mahkûmdu.
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100'],
            showTotal: (total) => `Toplam ${total} ders`,
          }}
          locale={{ emptyText: 'Bugün için tüm dersler proje girilmiş.' }}
        />
      )}
    </Card>
  );
};

export default MissingProjectsPanel;
